<template>
  <div class="modal fade" tabindex="-1" id="returnCaseModal" aria-labelledby="returnCaseModalLabel" aria-hidden="true"
       data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5 text-center">Devolver caso para fila</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  @click="hideModalReturnCase"></button>
        </div>
        <div class="modal-body">
          <p class="modal-text">
            <strong>Tem certeza de que deseja devolver o caso para a fila?</strong>
          </p>
          <p class="text-black-50">Lembre-se de que as informações preenchidas serão perdidas.</p>
          <select class="form-control" v-model="selectedReason">
            <option value="">Selecione o motivo da devolução</option>
            <option value="Troca de plantão">Troca de plantão</option>
            <option value="Encaminhamento interno para outro especialista">Encaminhamento interno para outro
              especialista
            </option>
            <option value="Outro">Outro</option>
          </select>
          <input class="form-control text-form-pep" v-if="selectedReason === 'Outro'" style="margin-top: 10px;"
                 v-model="otherReason" type="text" placeholder="Escreva aqui o motivo">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="hideModalReturnCase">Fechar
            janela
          </button>
          <button type="button" class="btn btn-primary"
                  @click="backProtocols" data-bs-dismiss="modal">Devolver para fila
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
  props: {
    visibleModalReturn: Boolean
  },
  computed: {
    ...mapGetters({Report: "StateReport"}),
  },
  data() {
    return {
      selectedReason: '',
      otherReason: ''
    }
  },
  methods: {
    ...mapActions(["DeleteReport"]),
    hideModalReturnCase() {
      this.$emit("hideModalReturnCase")
    },
    async backProtocols() {
      try {
        if (this.selectedReason === '') {
          this.$toast.error('Selecione o motivo da devolução.', {
            timeout: 3000,
            closeOnClick: true
          });
        } else {
          this.Report["reason"] = this.selectedReason === "Outro" ? this.otherReason : this.selectedReason;
          await this.DeleteReport(this.Report)
          this.$router.push('/protocols');
        }
      } catch (erro) {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },
  },
};
</script>

<style>

</style>
